import * as React from 'react';
import * as mobxReact from 'mobx-react';
import DefaultButton from '../../../../../global/default-button/default-button';
import { CreateZoomMeetingsVM } from '../create-zoom-meetings.viewmodel';
import { CommonModal } from '../../../../../global/modal/common/common-modal';
import { DefaultCloseModalButton } from '../../../../../global/modal/common/common-close-modal-buttons';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { SelectGroup } from '../../../../../global/select-group/select-group';
import './create-zoom-meetings-modal.scss';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';

interface IPresentationProps {
  vm: CreateZoomMeetingsVM;
  intl: IntlShape;
}

const CreateZoomMeetingsModal = injectIntl(mobxReact.observer((props: IPresentationProps) => {
  const {
    vm,
    intl
  } = props;

  const footer = <div className='buttons-block buttons-block--from-right'>
    <DefaultButton
      text={intl.formatMessage({
        id: 'eo.zoom.createZoomMeeting',
        description: 'Create Zoom Meetings',
        defaultMessage: 'Create Zoom Meetings'
      })}
      modifier={['fat', 'confirm-safe']}
      onClick={vm.createZoomMeetingsHandle}
    />
    <DefaultCloseModalButton />
  </div>;

  return (
    <>
      <CommonModal
        title={intl.formatMessage({
          id: 'eo.zoom.createZoomMeeting',
          description: 'Create Zoom Meetings',
          defaultMessage: 'Create Zoom Meetings'
        })}
        isOpen={vm.getIsFormShown()}
        onRequestClose={vm.hideForm}
        className='oe-modal-width'
        footer={footer}
      >
        <form className='oe-form'>
          <FormField label='Group'>
            <SelectGroup
              onChange={groupId => vm.setGroup(groupId)}
              value={vm.getGroup()}
              className='field w-100 oe-form-field__control'
            />
          </FormField>
          <FormField label='Meeting Topic'>
            <div className='input-topic-wrapper' >
              <span className='meeting-topic-hint m-right-10px'>
                <FormattedMessage
                  id='oe.zoom.hintLabelEventNameDate'
                  description='hint label event name date'
                  defaultMessage='Passport Title (or Event Name) - Presenter'
                />
              </span>
              <input
                className='oe-form-field__control'
                type='text'
                placeholder={intl.formatMessage({
                  id: 'oe.zoom.inputPlaceholder',
                  description: 'input placeholder',
                  defaultMessage: 'Enter additional text for the Topic'
                })}
                value={vm.getTopicText()}
                onChange={e => vm.setTopicText(e.target.value)}
              />
            </div>
            {vm.isFormChecked() && <span className='oe-form-field__error'>{vm.getTopicError()}</span>}
            <div className='meeting-topic-hint'>
              <FormattedMessage
                id='oe.zoom.hintNote'
                description='hint note'
                defaultMessage='Note: The maximum length of the meeting topic allowed by Zoom is 200 characters. If the total length of the topic is greater than this, generation of the Zoom meetings will fail.'
              />
            </div>
          </FormField>
        </form>
      </CommonModal>
    </>
  );
}));

export { CreateZoomMeetingsModal };
